import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ExecutionQTestData, ExecutionQTestDataObservations } from '../model/execution';
import { HttpUtils } from '../utils/httpUtils';

@Injectable({
  providedIn: 'root'
})
export class ExecutionQTestDataObservationsService {

  readonly baseUrl = `${environment.qualificatesUrl}/executionQTestDataObservations`;
  constructor(private http: HttpClient) { }

  save(data: ExecutionQTestDataObservations): Observable<any> {
    if (!data.id) {
      const url = `${this.baseUrl}/create`;
      return this.http.post(url, data).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    } else {
      const url = `${this.baseUrl}/${data.id}`;
      return this.http.put(url, data).pipe(map(httpRes => HttpUtils.extractData(httpRes)));

    }
  }

  delete(id: number): Observable<any> {
    const url = `${this.baseUrl}/${id}`;
    return this.http.delete(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  getAllByIdExecutionTest(id: number): Observable<any> {
    const url = `${this.baseUrl}/executionTest/${id}`;
    return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }
}
